module.exports = __webpack_public_path__ + "img/hostes-icon.37c8f6e4.svg";